<!-- 
BullentinContent.vue
功能：佈告欄管理_佈告欄內容
作者：i9400538 陳博承
完成：2021-07-08
-->
<template>
  <div class="container" v-show="isEdit">
    <div class="row">
      <div class="col-12">
        <h4 class="text-green m-0">發文注意事項：</h4>
      </div>
      <div class="col-12">
        <p>
          1. 不得發布身分證字號、保單號碼及其他『足資識別該個人之資料』相關資訊。
          <br />2. 上傳之文件或影片等文件不得構成著作財產權之侵害。
          <br />3. 若有發現違法之情事，經查屬實後管理者得將違法者停權並送人資議處。
          <br />
        </p>
      </div>
      <table class="table table-basic mt-4 mb-4" :class="{ 'readonly-table': isReadOnlyMode() }" @input="markAsEdited" @change="markAsEdited">
        <thead>
          <tr>
            <th class="w-220">輸入人員</th>
            <td>{{ getName }}</td>
          </tr>
          <tr>
            <th class="w-220">發文單位</th>
            <td>
              <input
                type="text"
                maxlength="20"
                :id="`div-name-${colKey}`"
                :data-vv-name="`div-name-${colKey}`"
                placeholder="請輸入發文單位"
                v-validate="'required'"
                data-vv-as="發文單位"
                class="form-control w-50"
                v-model="form.div_name"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`div-name-${colKey}`) }"
                @input="checkDivName"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">
              主旨
              <br />
              <small class="span-color-black">最多50個字元(25個中文字)</small>
            </th>
            <td>
              <input
                type="text"
                maxlength="50"
                :id="`bullentin-title-${colKey}`"
                :data-vv-name="`bullentin-title-${colKey}`"
                placeholder="請輸入主旨"
                v-validate="'required'"
                data-vv-as="主旨"
                class="form-control w-50"
                v-model="form.title"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`bullentin-title-${colKey}`) }"
                @input="checkTitle"
              />
            </td>
          </tr>
          <tr>
            <th class="w-220">
              內文
              <br />
              <small class="span-color-black">最多200個字元(100個中文字)</small>
            </th>
            <td>
              <textarea
                maxlength="200"
                :id="`bullentin-content-${colKey}`"
                :data-vv-name="`bullentin-content-${colKey}`"
                placeholder="請輸入內文"
                v-validate="'required'"
                data-vv-as="內文"
                class="text-area-pattern"
                v-model="form.content"
                alt="ch"
                :class="{ 'is-invalid': errors.has(`bullentin-content-${colKey}`) }"
                @input="checkContent"
                rows="4"
                cols="50"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th class="w-220">發佈日期</th>
            <td>
              <div class="col-10">
                <select
                  :id="`start-date-year-${colKey}`"
                  :data-vv-name="`start-date-year-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  v-model="form.start_date[0]"start_date
                  :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                  @change="updateDate('start')"
                >
                  <option value>年份</option>
                  <option
                    v-for="(opt, y_opt_i) in yearOpt_start"
                    :key="`start-year-${y_opt_i}`"
                    :value="opt"
                  >{{opt - 1911}}年</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`start-date-month-${colKey}`"
                  :data-vv-name="`start-date-month-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  v-model="form.start_date[1]"
                  :class="{ 'is-invalid': errors.has(`start-date-month-${colKey}`) }"
                  @change="updateDate('start')"
                >
                  <option value>月份</option>
                  <option
                    v-for="(opt, m_opt_i) in monthOpt"
                    :key="`start-month-${m_opt_i}`"
                    :value="opt"
                  >{{opt}}月</option>
                </select>

                <span class="text">/</span>

                <select
                  :id="`start-date-day-${colKey}`"
                  :data-vv-name="`start-date-day-${colKey}`"
                  v-validate="'required'"
                  data-vv-as="發佈日期"
                  class="form-control form-control-inline"
                  v-model="form.start_date[2]"
                  :class="{ 'is-invalid': errors.has(`start-date-day-${colKey}`) }"
                  @change="updateDate('start')"
                >
                  <option value>日期</option>
                  <option
                    v-for="(opt, d_opt_i) in dateOpt_start"
                    :key="`start-date-${d_opt_i}`"
                    :value="opt"
                  >{{opt}}日</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">下架日期</th>
            <td>
              <div class="col-10">
                <select
                  @change="updateDate('end')"
                  name="end-year"
                  id="end-year"
                  class="form-control form-control-inline"
                  v-model="form.end_date[0]"
                  :disabled="form.noEndDate"
                >
                  <option value>年份</option>
                  <option
                    v-for="(opt, y_opt_i) in yearOpt_end"
                    :key="`end-year-${y_opt_i}`"
                    :value="opt"
                  >{{opt - 1911}}年</option>
                </select>

                <span class="text">/</span>

                <select
                  @change="updateDate('end')"
                  name="end_month"
                  id="end-month"
                  class="form-control form-control-inline"
                  v-model="form.end_date[1]"
                  :disabled="form.noEndDate"
                >
                  <option value>月份</option>
                  <option
                    v-for="(opt, m_opt_i) in monthOpt"
                    :key="`end-month-${m_opt_i}`"
                    :value="opt"
                  >{{opt}}月</option>
                </select>

                <span class="text">/</span>

                <select
                  @change="updateDate('end')"
                  name="end_date"
                  id="end-date"
                  class="form-control form-control-inline"
                  v-model="form.end_date[2]"
                  :disabled="form.noEndDate"
                >
                  <option value>日期</option>
                  <option
                    v-for="(opt, d_opt_i) in dateOpt_end"
                    :key="`end-date-${d_opt_i}`"
                    :value="opt"
                  >{{opt}}日</option>
                </select>
                &nbsp;&nbsp;
                <div class="checkbox checkbox-inline">
                  <input type="checkbox" v-model="form.noEndDate" id="chk-no-end-date" @change="switchDisabled" />
                  <label for="chk-no-end-date">無下架時間</label>
                </div>
                <span class="text-red">*如欲立即下架，日期請選昨天</span>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">是否置頂</th>
            <td>
              <div
                class="radio radio-inline"
                v-for="(single, index) in isTopRadio"
                :key="`bulletin-istop-${index}`"
              >
                <input
                  type="radio"
                  :id="`bulletin-istop-${index}`"
                  name="bulletin-istop"
                  :value="single.value"
                  v-model="form.istop"
                />
                <label :for="`bulletin-istop-${index}`">{{ single.name }}</label>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">連結方式</th>
            <td>
              <div
                class="radio radio-inline"
                v-for="(single, index) in linkRadio"
                :key="`bulletin-link-${index}`"
              >
                <input
                  type="radio"
                  :id="`bulletin-link-${index}`"
                  name="bulletin-link"
                  :value="single.value"
                  v-model="form.link_way"
                />
                <label :for="`bulletin-link-${index}`">{{ single.name }}</label>
              </div>
            </td>
          </tr>
          <tr v-if="form.link_way == '1'">
            <th class="w-220">網頁連結</th>
            <td>
              <input
                type="text"
                class="form-control"
                :class="webLinkEmpty?'input-border-red':''"
                v-model="form.web_link"
                @change="setNotEmpty"
              />
            </td>
          </tr>
          <tr v-if="form.link_way == '2'">
            <th class="w-220">
              檔案位置
              <br />
              <small class="span-color-black">附件不得超過5MB</small>
            </th>
            <td>
              <div class="col-10 d-flex">
                <div v-if="form.filename && !isDelete">
                  <span class="text">{{form.filename}}</span>
                  <button type="button" class="btn btn-red" @click="doCleanFile">刪除</button>
                </div>
                <div class="d-flex" v-else>
                  <input id="file-upload" ref="myFiles" type="file" @change="changeInput()" />
                  <label for="file-upload" class="custom-file-upload btn btn-default m-0">上傳檔案</label>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="w-220">覆核人員</th>
            <td><span>{{form.approval_nm}}</span></td>
          </tr>
        </thead>
      </table>
      <div class="col-12">
        <div class="action text-right">
          <a class="btn btn-default" @click="doCancelEdit" v-show="showCancelEditBtn">回上頁</a>
          <a class="btn btn-default" @click="doReset(true)" v-show="showResetBtn">重設</a>
          <a class="btn btn-primary" @click="doSubmit(false)" v-show="showSubmitBtn" :class="{ 'disabled-link': !isModified }">送審</a>
          <a class="btn btn-primary" @click="doDelete" v-show="showDeleteBtn" :class="{ 'disabled-link': isDeleteDisabled }">取消申請</a>
          <a class="btn btn-primary" @click="doCopy" v-show="showCopyBtn">複製</a>
          <a class="btn btn-primary" @click="doSubmit(true)" v-show="showApproveBtn">覆核</a>
        </div>
      </div>
    </div>
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMaskContent" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import mxMask from "@/desktop/components/mxMask";
//service
import { callBullentinProcess } from "@/service";
export default {
  name: "BullentinContent",
  mixins: [commonMixin],
  components: { mxMask },
  props: {
    //佈告欄資訊
    bullentinInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    //編輯中
    isEdit: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    // 主旨連結
    editFromSubject: {
      type: Boolean,
      default: () => {
        return true;
      }
    }
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    getName(){
      return Object.keys(this.bullentinInfo).length != 0 ? this.bullentinInfo.upd_nm : this.UserInfo.name
    },
    showCancelEditBtn() {
      return (this.isEditMode && Object.keys(this.bullentinInfo).length !== 0);
    },
    showResetBtn() {
      return !this.isEditMode;
    },
    showSubmitBtn() {
      return this.editFromSubject && !(this.bullentinInfo.approval_status == 0 && this.bullentinInfo.release_status == 2)
    },
    showDeleteBtn() {
      return this.isEditMode && this.bullentinInfo.release_status != 2 && this.editFromSubject;
    },
    isDeleteDisabled() {
      return this.bullentinInfo.approval_status == 0;
    },
    showCopyBtn() {
      return this.isEditMode && this.bullentinInfo.approval_status == 0 && this.bullentinInfo.release_status == 2;
    },
    showApproveBtn() {
      return this.isEditMode && this.bullentinInfo.approval_status == 1 && !this.editFromSubject;
    }
  },
  watch: {
    isEdit: function(val) {
      if (val) {
        this.setFormValue();
      }
    }
  },
  data() {
    return {
      today: window.moment(),
      yearOpt_start: [],
      yearOpt_end: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dateOpt_start: [], //上架日期下拉選單
      dateOpt_end: [], //下架日期下拉選單
      mxMaskOpen: false,
      mxMaskContent: "資料儲存中，請稍候...",
      form: {
        ser_no: "", //序號
        name: "", //輸入人員
        div_no: "", //單位代號
        div_name: "", //單位名稱
        title: "", //主旨
        content: "", //內文
        start_date: ["", "", ""], //上架日期
        end_date: ["", "", ""], //下架日期
        noEndDate: false, //無下架時間
        istop: "N", //是否置頂
        link_way: 0, //連結方式
        web_link: "", //連結網址
        filename: "", //附件名稱
        emp_id: "",
        emp_name: "",
        mktdeptno: "", //區部代號
        upd_id: "",
        upd_nm: "",
        approval_id: "", //覆核人員ID
        approval_nm: ""  //覆核人員
      },
      isTopRadio: [
        {
          name: "否",
          value: "N"
        },
        {
          name: "是",
          value: "Y"
        }
      ],
      linkRadio: [
        {
          name: "無連結",
          value: 0
        },
        {
          name: "網頁連結",
          value: 1
        },
        {
          name: "檔案附件",
          value: 2
        }
      ],
      file: {},
      initFileName: "", //原檔名(編輯模式才有值)
      initLinkWay: "", //原有連結方式(編輯模式才有值)
      isDelete: false, //是否執行檔案刪除
      isUpload: false, //是否執行檔案上傳
      bullentinData: {},
      colKey: "1", //串欄位key用
      isEditMode: false,
      webLinkEmpty: false,
      isModified: false, //欄位是否異動

    };
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //是否為禁輸模式
    isReadOnlyMode(){
      if(!this.editFromSubject){
          if(this.bullentinInfo.approval_status == 0 &&
            this.bullentinInfo.release_status == 2){
            return true
          } else if (this.bullentinInfo.approval_status == 1){
            return true
          } else {
            return false
          }
      }else{
        if(this.bullentinInfo.approval_status == 0 &&
            this.bullentinInfo.release_status == 2){
              return true
        }else{
          return false
        }
      }
    },
    //是否欄位異動
    markAsEdited() {
      this.isModified = true;
    },
    //檢查發文單位
    checkDivName() {
      if (this.stringBytes(this.form.div_name, false, 20) > 20) {
        this.form.div_name = this.form.div_name.substring(
          0,
          this.stringBytes(this.form.div_name, true, 20)
        );
      }
    },
    //檢查主旨
    checkTitle() {
      if (this.stringBytes(this.form.title, false, 50) > 50) {
        this.form.title = this.form.title.substring(
          0,
          this.stringBytes(this.form.title, true, 50)
        );
      }
    },
    //檢查內文
    checkContent() {
      if (this.stringBytes(this.form.content, false, 200) > 200) {
        this.form.content = this.form.content.substring(
          0,
          this.stringBytes(this.form.content, true, 200)
        );
      }
    },
    //下架日期-下拉選單初始化
    updateDate(type) {
      let year = "";
      let month = "";
      if (type == "start") {
        year = this.form.start_date[0];
        month = this.form.start_date[1];
      } else {
        year = this.form.end_date[0];
        month = this.form.end_date[1];
      }
      if (!year || !month) return;
      let dt = new Date(year, month, 0).getDate();
      if (type == "start") {
        this.dateOpt_start = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_start.push(i + 1);
        }
      } else {
        this.dateOpt_end = [];
        for (let i = 0; i < dt; i++) {
          this.dateOpt_end.push(i + 1);
        }
      }
    },
    //重置空值顯示框
    setNotEmpty() {
      this.webLinkEmpty = false;
    },
    //清空檔案
    doCleanFile() {
      this.file = {};
      this.form.filename = "";
    },
    //整理更新資料
    doFormatData(reconfirm) {
      let errMsg = [];
      this.bullentinData = Object.assign({}, this.form);
      this.bullentinData.emp_id = this.UserInfo.id;
      if(!reconfirm){
          this.bullentinData.upd_id = this.UserInfo.id;
          this.bullentinData.upd_nm = this.UserInfo.name;
      }
      this.bullentinData.emp_name = this.UserInfo.name;
      this.bullentinData.div_no = this.UserInfo.divNo;
      this.bullentinData.mktdeptno = this.UserInfo.mktDeptNo;

      let startMonth =
        this.bullentinData.start_date[1].toString().length == 1
          ? "0" + this.bullentinData.start_date[1].toString()
          : this.bullentinData.start_date[1].toString();
      let startDate =
        this.bullentinData.start_date[2].toString().length == 1
          ? "0" + this.bullentinData.start_date[2].toString()
          : this.bullentinData.start_date[2].toString();

      this.bullentinData.start_date =
        this.form.start_date[0] + "-" + startMonth + "-" + startDate;

      let dd = new Date();
      let todayStr =
        dd.getFullYear() +
        "-" +
        parseInt(dd.getMonth() + 1) +
        "-" +
        dd.getDate();
      let d_Today = new Date(todayStr);
      let d_Start_Date = new Date(this.bullentinData.start_date);
      /*
      if (d_Today.getTime() > d_Start_Date.getTime()) {
        errMsg.push("發佈日期不得小於當日");
      }
      */

      if (this.form.noEndDate) {
        //無下架日期
        this.bullentinData.end_date = "";
      } else if (
        this.bullentinData.end_date[0] &&
        this.bullentinData.end_date[1] &&
        this.bullentinData.end_date[2]
      ) {
        let month =
          this.bullentinData.end_date[1].toString().length == 1
            ? "0" + this.bullentinData.end_date[1].toString()
            : this.bullentinData.end_date[1].toString();
        let date =
          this.bullentinData.end_date[2].toString().length == 1
            ? "0" + this.bullentinData.end_date[2].toString()
            : this.bullentinData.end_date[2].toString();
        this.bullentinData.end_date =
          this.form.end_date[0] + "-" + month + "-" + date;
        let d_End_Date = new Date(this.bullentinData.end_date);
        if (d_Start_Date.getTime() > d_End_Date.getTime()) {
          errMsg.push("下架日期不得早於發佈日");
        }
      } else {
        errMsg.push("下架日期不得為空值");
      }

      //連結方式
      if (this.form.link_way != "0") {
        if (this.form.link_way == "1" && this.form.web_link.trim() == "") {
          this.webLinkEmpty = true;
          errMsg.push("未輸入網頁連結");
        } else if (
          this.form.link_way == "2" &&
          this.form.filename.trim() == ""
        ) {
          errMsg.push("未上傳檔案附件");
        }
      }

      this.bullentinData.release_status	 = this.getReleaseStatus(this.bullentinData.start_date, this.bullentinData.end_date)

      if(!this.bullentinData.approval_status){
        if(this.editFromSubject){
          this.bullentinData.approval_status = 1
        }else{
          this.bullentinData.approval_status = 0
        }
      }else{
        this.bullentinData.approval_status = 1
      }

      //是否執行覆核操作
      this.bullentinData.reconfirm = reconfirm

      //覆核人員
      this.bullentinData.approval_id = this.$store.state.userInfo.id
      this.bullentinData.approval_nm = this.$store.state.userInfo.name

      //如果進行覆核操作，輸入人員不會變
      if(this.bullentinData.approval_status == 1 && reconfirm){
        this.bullentinData.approval_status = 0
      } else {
        // 非覆核操作，如果欄位有異動，輸入人員調整為當前業務員，若無異動則不變
        if(this.isModified){
          this.bullentinData.input_id = this.$store.state.userInfo.id
          this.bullentinData.input_name = this.$store.state.userInfo.name
        }    
      }

      return errMsg;
    },
    //編輯模式下檢查資料內容
    doEditCheck() {
      let errMsg = []
      if (this.initLinkWay != "2") {
        return; //原有資料有附件才需檢查
      }

      if (this.form.link_way != "2") {
        //原有連結方式為附檔，現在改為非附檔，需要刪除舊有檔案
        this.bullentinData.filename = "";
        this.bullentinData.needDelete = "Y";
        this.bullentinData.initFileName = this.initFileName;
      }

      if (this.file.name) {
        if (this.file.name != this.initFileName) {
          //確認檔案是否異動過，有異動才要刪除
          this.bullentinData.needDelete = "Y";
          this.bullentinData.initFileName = this.initFileName;
        } else {
          errMsg.push("上傳的檔案名稱不可跟之前的檔名一樣")
        }
      } else {
        //沒異動檔案, 不須重新上傳
        this.bullentinData.noNeedUpload = "Y";
      }
      return errMsg
    },
    doCancelEdit() {
      this.$emit("doCancelEdit");
    },
    //重設
    doReset(showMsg) {
      this.webLinkEmpty = false;
      this.form = {
        ser_no: "",
        div_no: "",
        div_name: "", //單位名稱
        title: "", //主旨
        content: "", //內文
        start_date: ["", "", ""], //上架日期
        end_date: ["", "", ""], //下架日期
        noEndDate: false, //無下架時間
        istop: "N", //是否置頂
        link_way: 0, //連結方式
        web_link: "", //連結網址
        filename: "", //附件名稱
        emp_id: "",
        emp_name: "",
        mktdeptno: "",
        upd_id: "",
        upd_nm: "",
        approval_nm: ""
      };
      if (showMsg) {
        this.$toast.info({ title: "畫面重設成功" });
      }
    },
    doDelete(){
        this.doFormatData(false);
        this.doEditCheck();
        callBullentinProcess(this.UserInfo.id, this.bullentinData, "4", "").then(
          result => {
            if (result.header && result.header.status == "200") {
              this.setToastMsg(result.header.message);
              this.$emit("doQuery", this.bullentinData.start_date);
            } else {
              this.setToastMsg(result.header.message);
            }
          }
       );
    },
    doCopy(){
        this.$router.push({
          name: "backend-tab2",
          params:{
            cloneData:{
               dvnm: this.bullentinInfo.dvnm,
               subject: this.bullentinInfo.subject,
               words: this.bullentinInfo.words,
            }
          } 
        });
    },
    doSubmit(reconfirm) {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        let errMsg = this.doFormatData(reconfirm);
        if (errMsg && errMsg.length > 0) {
          errMsg.forEach(err => {
            this.$toast.info({ title: err }); //印出檢核後的錯誤訊息
          });
          return;
        }

        let isEdit = this.form.ser_no != ""; //編輯模式
        if (isEdit) {
          let errMsg  = this.doEditCheck(); //編輯模式下才去檢查資料內容
          if (errMsg && errMsg.length > 0) {
          errMsg.forEach(err => {
            this.$toast.info({ title: err }); //印出檢核後的錯誤訊息
          });
          return;
        }
        }

        this.mxMaskOpen = true;
        // 使用 formData 上傳檔案
        callBullentinProcess(
          this.UserInfo.id,
          this.bullentinData,
          isEdit ? "3" : "2",
          this.form.link_way == "2" ? (this.file.name ? this.file : "") : ""
        ).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.setToastMsg(result.header.message);
            if (isEdit) {
              //編輯成功, 關閉編輯區塊, 重新查詢
              this.$emit("doQuery", this.bullentinData.start_date);
            } else {
              //新增成功, 導頁到佈告欄查詢頁面
              this.$router.push({
                name: "backend-tab2-2",
                params: {
                  start_date: this.bullentinData.start_date
                }
              });
            }
          } else {
            this.setToastMsg(result.header.message);
          }
        });
      });
    },
    //檔案上傳
    changeInput() {
      let vm = this;
      if (!vm.$refs.myFiles.files || vm.$refs.myFiles.files.length == 0) {
        return; //瀏覽檔案點選取消不處理
      }
      vm.file = vm.$refs.myFiles.files[0];
      let fileType = vm.file.type;
      //檢查檔案類型 (只允許 application/pdf, image/png, image/jpeg)
      if (
        fileType.indexOf("pdf") !== -1 ||
        fileType.indexOf("png") !== -1 ||
        fileType.indexOf("jpeg") !== -1
      ) {
        //檢查檔案大小
        if (vm.$refs.myFiles.files[0].size > 5000000) {
          vm.setToastMsg("檔案大小不得超過5MB");
          vm.file = {};
          vm.form.filename = "";
        } else {
          vm.file = vm.$refs.myFiles.files[0];
          vm.form.filename = vm.file.name;
        }
      } else {
        vm.setToastMsg("檔案格式不支援");
        vm.file = {};
        vm.form.filename = "";
      }
    },
    //編輯模式塞值
    setFormValue() {
      if (this.bullentinInfo && this.bullentinInfo.ser_no != "") {
        this.doReset(false); //清空畫面上原有的值
        this.isEditMode = true;
        this.form.ser_no = this.bullentinInfo.ser_no;
        this.form.div_name = this.bullentinInfo.dvnm;
        this.form.title = this.bullentinInfo.subject;
        this.form.content = this.bullentinInfo.words;
        this.form.upd_nm = this.bullentinInfo.upd_nm;
        this.form.upd_id = this.bullentinInfo.upd_id;

        let start_date = this.bullentinInfo.star_date || "";
        if (start_date) {
          let start_dateArr = start_date.split("-");
          this.form.start_date[0] = start_dateArr[0]; //年
          if (parseInt(start_dateArr[1]) > 9) {
            this.form.start_date[1] = start_dateArr[1]; //月
          } else {
            this.form.start_date[1] = start_dateArr[1].replace("0", ""); //月 (去除0)
          }
          this.updateDate("start");
          if (parseInt(start_dateArr[2]) > 9) {
            this.form.start_date[2] = start_dateArr[2]; //日
          } else {
            this.form.start_date[2] = start_dateArr[2].replace("0", ""); //日 (去除0)
          }
          if (!this.yearOpt_start.includes(parseInt(this.form.start_date[0]))) {
            this.form.start_date[0] = "";
          }
        }

        let end_date = this.bullentinInfo.end_date || "";
        if (end_date) {
          let end_dateArr = end_date.split("-");
          this.form.end_date[0] = end_dateArr[0]; //年
          if (parseInt(end_dateArr[1]) > 9) {
            this.form.end_date[1] = end_dateArr[1]; //月
          } else {
            this.form.end_date[1] = end_dateArr[1].replace("0", ""); //月 (去除0)
          }
          this.updateDate("end");
          if (parseInt(end_dateArr[2]) > 9) {
            this.form.end_date[2] = end_dateArr[2]; //日
          } else {
            this.form.end_date[2] = end_dateArr[2].replace("0", ""); //日 (去除0)
          }
          if (!this.yearOpt_end.includes(parseInt(this.form.end_date[0]))) {
            this.form.end_date[0] = "";
          }
        } else {
          this.form.noEndDate = true;
        }

        this.form.istop = this.bullentinInfo.istop;
        this.form.link_way = this.bullentinInfo.link_way;
        this.initLinkWay = this.bullentinInfo.link_way;
        this.form.web_link = this.bullentinInfo.http || "";
        this.form.filename = this.bullentinInfo.filename || "";
        this.initFileName = this.bullentinInfo.filename || "";
        this.form.approval_nm = this.bullentinInfo.approval_nm || "";
      }
    },
    getReleaseStatus(s_date, e_date){
          const [sy, sm, sd] = s_date.split('-').map(Number);
          const startDate = new Date(sy, sm - 1, sd);

          let endDate = null;
          if (e_date) {
            const [ey, em, ed] = e_date.split('-').map(Number);
            endDate = new Date(ey, em - 1, ed);
          }

          const currentDate = new Date();
          currentDate.setHours(0, 0, 0, 0);
          startDate.setHours(0, 0, 0, 0);
          if (endDate) endDate.setHours(0, 0, 0, 0);

          if (currentDate < startDate) {
            return 0;
          }

          if (endDate && currentDate > endDate) {
            return 2;
          }

          return 1;
    },
    //切換無下架時間
    switchDisabled(){
      if(this.form.noEndDate){
        this.form.end_date.forEach( (item,index) =>
             this.form.end_date[index] = ''
        )
      }
    }
  },
  mounted() {
    const cloneData = this.$route.params.cloneData
    if(cloneData){
      this.form.div_name = cloneData.dvnm
      this.form.title = cloneData.subject
      this.form.content = cloneData.words
    }
    let start = this.today.year();
    for (let s = start; s <= start + 2; s++) {
      this.yearOpt_start.push(s);
      this.yearOpt_end.push(s);
    }
  }
};
</script>
<style>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
.span-color-black {
  color: black;
}
.text-area-pattern {
  padding: 9px 10px;
  border: 1px solid #c2c4c7;
  border-radius: 4px;
  font-size: 16px !important;
  line-height: 1 !important;
  resize: none;
}
.text-area-height {
  height: 250px;
}
.readonly-table {
  pointer-events: none; /* 禁用點擊 */
}
.readonly-table input,
.readonly-table select,
.readonly-table textarea,
.readonly-table button,
.readonly-table label,
.readonly-table .custom-file-upload {
  pointer-events: none;
  filter: grayscale(100%);
  background-color: #f5f5f5 !important; 
  color: #999 !important;
  border-color: #ccc !important;
  cursor: not-allowed; 
}

.readonly-table input[type="checkbox"],
.readonly-table input[type="radio"] {
  opacity: 0.6;
}

.disabled-link {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
  background: #C2C4C7 !important;
  pointer-events: none;
  cursor: not-allowed;
}
</style>